const exerciseData = [
    {
        name: "1",
        tasks: [{
            id: "1", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: true },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 1, value: 1 }]
        },
        {
            id: "2", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: true },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 1, value: 1 }]
        },
        {
            id: "3", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 180 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: true },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 1, value: 1 }]
        },
        {
            id: "4", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 180 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: true },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 1, value: 1 }]
        },
        {
            id: "5", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: true },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "6", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: true },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 0, value: 1 }]
        },
        {
            id: "7", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 180 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: true },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "8", chapter: 1,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 180 }, tiles:
                [
                    { positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: true },
                    { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 0, value: 1 }]
        },
        {
            id: "9a", chapter: 1,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: { bottom: true }, success: true },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { top: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { top: true, left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "lemon", positionVertical: 0, positionHorizontal: 0, value: 1 }]
        },
        {
            id: "9b", chapter: 1,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: { bottom: true }, success: true },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { top: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { top: true, left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "lemon", positionVertical: 0, positionHorizontal: 0, value: 1 }]
        }
        ]
    },
    {
        name: "2",
        tasks: [{
            id: "10a", chapter: 2,
            turtleData: { positionVertical: 0, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { right: true } },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true } },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { left: true } },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true } },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true } },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { left: true } },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true } },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true } },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { left: true } }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 1, value: 1 }],
            solution: "bk 100 bk 100"
        },
        {
            id: "10b", chapter: 2,
            turtleData: { positionVertical: 0, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: true },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 1, value: 1 }]
        },
        {
            id: "11", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 2, value: 1 }],
            solution: "rt 90 fd 100 fd 100"
        },
        {
            id: "12a", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 2, direction: 0 }, tiles:
                [
                    { positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { bottom: true }, success: false },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: false, walls: { bottom: true }, success: false },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { bottom: true }, success: false },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { top: true }, success: true },
                    { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true }, success: false },
                    { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { top: true }, success: false },
                    { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 0, value: 1 }]
        },
        {
            id: "12b", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 2, direction: 0 }, tiles:
                [
                    { positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { bottom: true }, success: false },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: false, walls: { bottom: true }, success: false },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { bottom: true }, success: false },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { top: true }, success: true },
                    { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true }, success: false },
                    { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { top: true }, success: false },
                    { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                    { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 0, value: 1 }]
        },
        {
            id: "13", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: false, walls: { left: true, top: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: false, walls: { left: true, right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: true }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "14", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [
                    { positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: {}, success: false },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: false, walls: { right: true, bottom: true }, success: false },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: true },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true, bottom: true }, success: false },
                    { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true, left: true }, success: false },
                    { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { bottom: true }, success: false },
                    { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { top: true }, success: false },
                    { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { right: true }, success: false },
                    { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { top: true, left: true }, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "15", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { top: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: true }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "16", chapter: 2,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true, bottom: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { top: true }, success: true },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { top: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 0, value: 1 }]
        },
        {
            id: "17a", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: { bottom: true }, success: true },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: false, walls: { top: true, left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { top: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "17b", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: { bottom: true }, success: true },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: false, walls: { top: true, left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { top: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "18a", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true, left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { top: true }, success: true },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "18b", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true, left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { top: true }, success: true },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 1, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "19", chapter: 2,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { bottom: true }, success: true },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: false, walls: { top: true, bottom: true, left: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { top: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 1, value: 1 }]
        }
        ]
    },
    {
        name: "3",
        tasks: [{
            id: "20", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: true },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "circle-orange", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "circle-pink", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "circle-green", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "circle-purple", positionVertical: 1, positionHorizontal: 0, value: 1 },
            { id: "circle-yellow", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "circle-black", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "circle-blue", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "21", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: true }],
            specialObjects: [{ id: "circle-orange", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "circle-pink", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "circle-green", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "circle-purple", positionVertical: 1, positionHorizontal: 0, value: 1 },
            { id: "circle-yellow", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "circle-black", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "circle-blue", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "22", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: true },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "circle-orange", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "circle-pink", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "circle-green", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "circle-purple", positionVertical: 1, positionHorizontal: 0, value: 1 },
            { id: "circle-yellow", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 2, value: 1, forbiddenElement: true },
            { id: "circle-black", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "circle-blue", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "23", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: true },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "circle-orange", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "circle-pink", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "circle-green", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "circle-purple", positionVertical: 1, positionHorizontal: 0, value: 1, forbiddenElement: true },
            { id: "circle-yellow", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "circle-black", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "circle-blue", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "24", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "circle-orange", positionVertical: 0, positionHorizontal: 0, value: 'orange' },
            { id: "circle-pink", positionVertical: 0, positionHorizontal: 1, value: '' },
            { id: "circle-green", positionVertical: 0, positionHorizontal: 2, value: 'green' },
            { id: "circle-purple", positionVertical: 1, positionHorizontal: 0, value: '' },
            { id: "circle-yellow", positionVertical: 1, positionHorizontal: 1, value: '' },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 2, value: '' },
            { id: "circle-black", positionVertical: 2, positionHorizontal: 1, value: 'black' },
            { id: "circle-blue", positionVertical: 2, positionHorizontal: 2, value: '' }],
            goal: { type: "concat", solution: "orangeblackgreen" }
        },
        {
            id: "25", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "rectangle-red", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "triangle-green", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "cross-red", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "cross-blue", positionVertical: 1, positionHorizontal: 0, value: 1 },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "triangle-blue", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "rectangle-blue", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "circle-green", positionVertical: 2, positionHorizontal: 2, value: 1 }],
            solution: "lt 90 bk 100 bk 100 rt 90 fd 100"
        },
        {
            id: "26", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: true },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "rectangle-red", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "triangle-green", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "cross-red", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "cross-blue", positionVertical: 1, positionHorizontal: 0, value: 1 },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "triangle-blue", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "rectangle-blue", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "circle-green", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "27", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: true },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "rectangle-red", positionVertical: 0, positionHorizontal: 0, value: 'red' },
            { id: "triangle-green", positionVertical: 0, positionHorizontal: 1, value: 'green' },
            { id: "cross-red", positionVertical: 0, positionHorizontal: 2, value: 'red' },
            { id: "cross-blue", positionVertical: 1, positionHorizontal: 0, value: 'blue' },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 1, value: 'red' },
            { id: "triangle-blue", positionVertical: 1, positionHorizontal: 2, value: 'blue' },
            { id: "rectangle-blue", positionVertical: 2, positionHorizontal: 1, value: 'blue' },
            { id: "circle-green", positionVertical: 2, positionHorizontal: 2, value: 'green' }],
            goal: { type: "collect", elements: "blue" }
        },
        {
            id: "28", chapter: 3,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: true },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "rectangle-red", positionVertical: 0, positionHorizontal: 0, value: 'red' },
            { id: "triangle-green", positionVertical: 0, positionHorizontal: 1, value: 'green' },
            { id: "cross-red", positionVertical: 0, positionHorizontal: 2, value: 'red', forbiddenElement: true },
            { id: "cross-blue", positionVertical: 1, positionHorizontal: 0, value: 'blue', forbiddenElement: true },
            { id: "circle-red", positionVertical: 1, positionHorizontal: 1, value: 'red' },
            { id: "triangle-blue", positionVertical: 1, positionHorizontal: 2, value: 'blue' },
            { id: "rectangle-blue", positionVertical: 2, positionHorizontal: 1, value: 'blue' },
            { id: "circle-green", positionVertical: 2, positionHorizontal: 2, value: 'green' }],
            goal: { type: "collect", elements: "green" }
        }
        ]
    },
    {
        name: "4",
        tasks: [{
            id: "29", chapter: 4,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "strawberry", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "strawberry", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "strawberry", positionVertical: 1, positionHorizontal: 0, value: 1 },
            { id: "strawberry", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "strawberry", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "strawberry", positionVertical: 2, positionHorizontal: 0, value: 1 },
            { id: "strawberry", positionVertical: 2, positionHorizontal: 2, value: 1 }],
            goal: 8
        },
        {
            id: "30", chapter: 4,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "2strawberry", positionVertical: 0, positionHorizontal: 2, value: 2 },
            { id: "3strawberry", positionVertical: 1, positionHorizontal: 0, value: 3 },
            { id: "4strawberry", positionVertical: 1, positionHorizontal: 2, value: 4 }],
            solution: 'fd 100 lt 90 fd 100'
        },
        {
            id: "31", chapter: 4,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "2strawberry", positionVertical: 0, positionHorizontal: 2, value: 2 },
            { id: "3strawberry", positionVertical: 1, positionHorizontal: 0, value: 3 },
            { id: "4strawberry", positionVertical: 1, positionHorizontal: 2, value: 4 }],
            goal: 4
        },
        {
            id: "32a", chapter: 4,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "2strawberry", positionVertical: 0, positionHorizontal: 2, value: 2 },
            { id: "3strawberry", positionVertical: 1, positionHorizontal: 0, value: 3 },
            { id: "4strawberry", positionVertical: 1, positionHorizontal: 2, value: 4 }],
            goal: 5
        },
        {
            id: "32b", chapter: 4,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "2strawberry", positionVertical: 0, positionHorizontal: 2, value: 2 },
            { id: "3strawberry", positionVertical: 1, positionHorizontal: 0, value: 3 },
            { id: "4strawberry", positionVertical: 1, positionHorizontal: 2, value: 4 }],
            goal: 6
        },
        {
            id: "33", chapter: 4,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "2strawberry", positionVertical: 0, positionHorizontal: 2, value: 2 },
            { id: "3strawberry", positionVertical: 1, positionHorizontal: 0, value: 3 },
            { id: "4strawberry", positionVertical: 1, positionHorizontal: 2, value: 4 }],
            goal: 9
        },
        {
            id: "34", chapter: 4,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "4strawberry", positionVertical: 0, positionHorizontal: 0, value: 4 },
            { id: "strawberry", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "2strawberry", positionVertical: 0, positionHorizontal: 2, value: 2 },
            { id: "strawberry", positionVertical: 1, positionHorizontal: 0, value: 1 },
            { id: "3strawberry", positionVertical: 1, positionHorizontal: 1, value: 3 },
            { id: "4strawberry", positionVertical: 1, positionHorizontal: 2, value: 4 },
            { id: "3strawberry", positionVertical: 2, positionHorizontal: 0, value: 3 },
            { id: "strawberry", positionVertical: 2, positionHorizontal: 2, value: 1 }],
            goal: 9
        }
        ]
    },
    {
        name: "5",
        tasks: [{
            id: "35", chapter: 5,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: {} }],
            specialObjects: [{ id: "character", positionVertical: 0, positionHorizontal: 0, value: "N" },
            { id: "character", positionVertical: 0, positionHorizontal: 1, value: "N" },
            { id: "character", positionVertical: 1, positionHorizontal: 0, value: "A" },
            { id: "character", positionVertical: 1, positionHorizontal: 1, value: "A" },
            { id: "character", positionVertical: 2, positionHorizontal: 0, value: "J" }],
            solution: "fd 100 fd 100 lt 90 fd 100 lt 90 fd 100"
        },
        {
            id: "36", chapter: 5,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: {} }],
            specialObjects: [{ id: "character", positionVertical: 0, positionHorizontal: 0, value: "N" },
            { id: "character", positionVertical: 0, positionHorizontal: 1, value: "O" },
            { id: "character", positionVertical: 1, positionHorizontal: 0, value: "I" },
            { id: "character", positionVertical: 1, positionHorizontal: 1, value: "M" },
            { id: "character", positionVertical: 2, positionHorizontal: 0, value: "S" }],
            solution: "lt 90 fd 100 rt 90 fd 100 rt 90 fd 100 lt 90 fd 100 lt 90 fd 100"
        },
        {
            id: "37", chapter: 5,
            turtleData: { positionVertical: 2, positionHorizontal: 2, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "character", positionVertical: 0, positionHorizontal: 0, value: "R" },
            { id: "character", positionVertical: 0, positionHorizontal: 1, value: "L" },
            { id: "character", positionVertical: 0, positionHorizontal: 2, value: "U" },
            { id: "character", positionVertical: 1, positionHorizontal: 0, value: "E" },
            { id: "character", positionVertical: 1, positionHorizontal: 1, value: "L" },
            { id: "character", positionVertical: 1, positionHorizontal: 2, value: "P" },
            { id: "character", positionVertical: 2, positionHorizontal: 0, value: "V" },
            { id: "character", positionVertical: 2, positionHorizontal: 1, value: "O" }],
            solution: "fd 100 fd 100 lt 90 fd 100 lt 90 fd 100 fd 100 rt 90 fd 100 rt 90 fd 100 fd 100"
        },
        {
            id: "38", chapter: 5,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "character", positionVertical: 0, positionHorizontal: 0, value: "1" },
            { id: "character", positionVertical: 0, positionHorizontal: 1, value: "." },
            { id: "character", positionVertical: 0, positionHorizontal: 2, value: "1" },
            { id: "character", positionVertical: 1, positionHorizontal: 0, value: "2" },
            { id: "character", positionVertical: 1, positionHorizontal: 1, value: "2" },
            { id: "character", positionVertical: 1, positionHorizontal: 2, value: "2" },
            { id: "character", positionVertical: 2, positionHorizontal: 1, value: "1" },
            { id: "character", positionVertical: 2, positionHorizontal: 2, value: "." }],
            solution: "fd 100 fd 100 rt 90 fd 100 fd 100 rt 90 fd 100 fd 100 rt 90 fd 100 rt 90 fd 100"
        },
        {
            id: "39a", chapter: 5,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "character", positionVertical: 0, positionHorizontal: 0, value: "A" },
            { id: "character", positionVertical: 0, positionHorizontal: 1, value: "R" },
            { id: "character", positionVertical: 0, positionHorizontal: 2, value: "A" },
            { id: "character", positionVertical: 1, positionHorizontal: 0, value: "E" },
            { id: "character", positionVertical: 1, positionHorizontal: 1, value: "T" },
            { id: "character", positionVertical: 1, positionHorizontal: 2, value: "L" },
            { id: "character", positionVertical: 2, positionHorizontal: 0, value: "P" },
            { id: "character", positionVertical: 2, positionHorizontal: 2, value: "U" }],
            goal: { type: "concat", solution: "PETRA" }
        },
        {
            id: "39b", chapter: 5,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "character", positionVertical: 0, positionHorizontal: 0, value: "A" },
            { id: "character", positionVertical: 0, positionHorizontal: 1, value: "R" },
            { id: "character", positionVertical: 0, positionHorizontal: 2, value: "A" },
            { id: "character", positionVertical: 1, positionHorizontal: 0, value: "E" },
            { id: "character", positionVertical: 1, positionHorizontal: 1, value: "T" },
            { id: "character", positionVertical: 1, positionHorizontal: 2, value: "L" },
            { id: "character", positionVertical: 2, positionHorizontal: 0, value: "P" },
            { id: "character", positionVertical: 2, positionHorizontal: 2, value: "U" }],
            goal: { type: "concat", solution: "ULA" }
        }
        ],
    },
    {
        name: "6",
        tasks: [{
            id: "40a", chapter: 6,
            turtleData: { positionVertical: 4, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: true },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 4, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 4, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 4, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false }
                ],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 1, value: 1 },
            ]
        },
        {
            id: "40b", chapter: 6,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: true },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: false, walls: { left: true }, success: false }
                ],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 1, value: 1 },
            ]
        },
        {
            id: "41a", chapter: 6,
            turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {}, success: true }],
            specialObjects: [
                { id: "strawberry", positionVertical: 3, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "41b", chapter: 6,
            turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {}, success: true },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {}, success: false }],
            specialObjects: [
                { id: "strawberry", positionVertical: 1, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "41c", chapter: 6,
            turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {}, success: true },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {}, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 0, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "42", chapter: 6,
            turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {}, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: false, walls: { top: true, left: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: { top: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: false, walls: { left: true }, success: false },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: { left: true }, success: true }
                ],
            specialObjects: [{ id: "strawberry", positionVertical: 3, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "43", chapter: 6,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {}, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { left: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: { left: true, bottom: true }, success: true },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: false, walls: { right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: { left: true, right: true }, success: false },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: false, walls: { left: true, top: true }, success: false }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 2, value: 1 }]
        },
        {
            id: "44", chapter: 6,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: false, walls: { bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: { top: true }, success: false },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: { top: true, bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: { top: true, bottom: true }, success: false },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: { top: true }, success: false },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: { right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: false, walls: { left: true, top: true }, success: false },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: false, walls: { top: true, right: true }, success: false },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: { left: true }, success: true }],
            specialObjects: [{ id: "strawberry", positionVertical: 2, positionHorizontal: 3, value: 1 }]
        },

        ]
    },
    {
        name: "7",
        tasks: [{
            id: "45", chapter: 7,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 0, y2: 1, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 0, y2: 2, color: "#e6e6e6" }]
        },
        {
            id: "46", chapter: 7,
            turtleData: { positionVertical: 1, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 1, x2: 0, y2: 0, color: "#e6e6e6" },
            { x1: 0, y1: 0, x2: 1, y2: 0, color: "#e6e6e6" },
            { x1: 1, y1: 0, x2: 1, y2: 1, color: "#e6e6e6" },
            { x1: 1, y1: 1, x2: 2, y2: 1, color: "#e6e6e6" },
            { x1: 2, y1: 1, x2: 2, y2: 0, color: "#e6e6e6" }]
        },
        {
            id: "47", chapter: 7,
            turtleData: { positionVertical: 1, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 1, x2: 0, y2: 0, color: "#e6e6e6" },
            { x1: 0, y1: 0, x2: 1, y2: 0, color: "#e6e6e6" },
            { x1: 1, y1: 0, x2: 1, y2: 1, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#e6e6e6" }]
        },
        {
            id: "48", chapter: 7,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }
                ],
            specialObjects: []
        },
        {
            id: "49", chapter: 7,
            turtleData: { positionVertical: 1, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 1, x2: 0, y2: 0, color: "#e6e6e6" },
            { x1: 0, y1: 0, x2: 1, y2: 0, color: "#e6e6e6" },
            { x1: 1, y1: 0, x2: 2, y2: 0, color: "#e6e6e6" },
            { x1: 2, y1: 0, x2: 2, y2: 1, color: "#e6e6e6" },
            { x1: 1, y1: 1, x2: 2, y2: 1, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#e6e6e6" }]
        },
        {
            id: "50", chapter: 7,
            turtleData: { positionVertical: 0, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 1, y2: 0, color: "#e6e6e6" },
            { x1: 1, y1: 0, x2: 1, y2: 1, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 0, y2: 2, color: "#e6e6e6" },
            { x1: 0, y1: 2, x2: 1, y2: 2, color: "#e6e6e6" }]
        },
        {
            id: "51", chapter: 7,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 1, y2: 0, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#e6e6e6" },
            { x1: 0, y1: 2, x2: 1, y2: 2, color: "#e6e6e6" },
            { x1: 1, y1: 0, x2: 1, y2: 1, color: "#e6e6e6" },
            { x1: 1, y1: 1, x2: 1, y2: 2, color: "#e6e6e6" }]
        },
        {
            id: "52", chapter: 7,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }
                ],
            specialObjects: []
        }
        ]
    },
    {
        name: "8",
        tasks: [{
            id: "53", chapter: 8,
            turtleData: { positionVertical: 2, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 1, y2: 0, color: "#BFD7E0" },
            { x1: 1, y1: 0, x2: 2, y2: 0, color: "#BFD7E0" },
            { x1: 1, y1: 0, x2: 1, y2: 1, color: "#BFD7E0" },
            { x1: 1, y1: 1, x2: 1, y2: 2, color: "#BFD7E0" }]
        },
        {
            id: "54", chapter: 8,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 0, y2: 2, color: "#BFD7E0" },
            { x1: 0, y1: 0, x2: 2, y2: 0, color: "#D6E3BD" },
            { x1: 2, y1: 0, x2: 2, y2: 2, color: "#FFF7D3" },
            { x1: 0, y1: 2, x2: 2, y2: 2, color: "#FFE5E6" }]
        },
        {
            id: "55", chapter: 8,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 1, y1: 1, x2: 1, y2: 0, color: "#BFD7E0" },
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#D6E3BD" },
            { x1: 0, y1: 1, x2: 0, y2: 2, color: "#FFF7D3" },
            { x1: 1, y1: 0, x2: 2, y2: 0, color: "#FFE5E6" }]
        },
        {
            id: "56", chapter: 8,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 1, x2: 2, y2: 1, color: "#FFE5E6" },
            { x1: 1, y1: 0, x2: 1, y2: 2, color: "#FFE5E6" }]
        },
        ]
    },
    {
        name: "9",
        tasks: [{
            id: "57", chapter: 9,
            turtleData: { positionVertical: 0, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 4, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 5, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 1, y2: 0, color: "#BFD7E0" },
            { x1: 2, y1: 0, x2: 3, y2: 0, color: "#BFD7E0" },
            { x1: 4, y1: 0, x2: 5, y2: 0, color: "#BFD7E0" }]
        },
        {
            id: "58", chapter: 9,
            turtleData: { positionVertical: 1, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 0, y2: 1, color: "#D6E3BD" },
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#D6E3BD" },
            { x1: 2, y1: 0, x2: 2, y2: 1, color: "#D6E3BD" },
            { x1: 2, y1: 1, x2: 3, y2: 1, color: "#D6E3BD" }]
        },
        {
            id: "59", chapter: 9,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 4, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 4, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 5, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 4, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 1, x2: 2, y2: 1, color: "#FFE5E6" },
            { x1: 3, y1: 1, x2: 5, y2: 1, color: "#FFE5E6" },
            { x1: 1, y1: 0, x2: 1, y2: 2, color: "#FFE5E6" },
            { x1: 4, y1: 0, x2: 4, y2: 2, color: "#FFE5E6" }]
        },
        {
            id: "60", chapter: 9,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 1, x2: 0, y2: 2, color: "#D6E3BD" },
            { x1: 1, y1: 0, x2: 2, y2: 0, color: "#D6E3BD" },
            { x1: 3, y1: 1, x2: 3, y2: 2, color: "#D6E3BD" },
            { x1: 1, y1: 3, x2: 2, y2: 3, color: "#D6E3BD" }]
        },
        ]
    },
    {
        name: "10",
        tasks: [
            {
                id: "63", chapter: 10,
                turtleData: { positionVertical: 0, positionHorizontal: 0, direction: 90 }, tiles:
                    [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 4, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 5, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 4, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 5, isAllowed: true, walls: {} }],
                specialObjects: [],
                lines: [{ x1: 5, y1: 0, x2: 5, y2: 1, color: "#e6e6e6" },
                { x1: 0, y1: 0, x2: 5, y2: 0, color: "#e6e6e6" },
                { x1: 0, y1: 1, x2: 5, y2: 1, color: "#e6e6e6" }]
            },
            {
                id: "64", chapter: 10,
                turtleData: { positionVertical: 0, positionHorizontal: 3, direction: 90 }, tiles:
                    [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} }
                    ],
                specialObjects: [],
                lines: [{ x1: 0, y1: 0, x2: 3, y2: 0, color: "#e6e6e6" },
                { x1: 0, y1: 0, x2: 0, y2: 1, color: "#e6e6e6" }]
            },
            {
                id: "65", chapter: 10,
                turtleData: { positionVertical: 0, positionHorizontal: 7, direction: 90 }, tiles:
                    [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 4, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 5, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 6, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 7, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} }
                    ],
                specialObjects: [],
                lines: [{ x1: 0, y1: 0, x2: 7, y2: 0, color: "#e6e6e6" },
                { x1: 0, y1: 0, x2: 0, y2: 1, color: "#e6e6e6" }]
            },
            {
                id: "66", chapter: 10,
                turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                    [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                    { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                    { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }],
                specialObjects: [],
                lines: [{ x1: 0, y1: 0, x2: 3, y2: 0, color: "#e6e6e6" },
                { x1: 0, y1: 3, x2: 3, y2: 3, color: "#e6e6e6" },
                { x1: 0, y1: 0, x2: 0, y2: 3, color: "#e6e6e6" },
                { x1: 3, y1: 0, x2: 3, y2: 3, color: "#e6e6e6" }]
            },
            {
                id: "67", chapter: 10,
                turtleData: { positionVertical: 0, positionHorizontal: 0, direction: 270 }, tiles:
                    [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                    { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                    { positionVertical: 2, positionHorizontal: 4, isAllowed: true, walls: {} },
                    { positionVertical: 2, positionHorizontal: 5, isAllowed: true, walls: {} },
                    { positionVertical: 2, positionHorizontal: 6, isAllowed: true, walls: {} }
                    ],
                specialObjects: [],
                lines: [{ x1: 0, y1: 0, x2: 3, y2: 0, color: "#e6e6e6" },
                { x1: 3, y1: 0, x2: 3, y2: 2, color: "#e6e6e6" },
                { x1: 3, y1: 2, x2: 6, y2: 2, color: "#e6e6e6" }]
            }
        ]
    },
    {
        name: "11",
        tasks: [{
            id: "68", chapter: 11,
            turtleData: { positionVertical: 0, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 4, positionHorizontal: 0, isAllowed: true, walls: {} }
                ],
            specialObjects: [{ id: "house-blue", positionVertical: 4, positionHorizontal: 0, value: 1 }],
            lines: [{ x1: 0, y1: 0, x2: 0, y2: 4, color: "#000000" }]
        },
        {
            id: "69", chapter: 11,
            turtleData: { positionVertical: 0, positionHorizontal: 3, direction: 90 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} }
                ],
            specialObjects: [{ id: "house-blue", positionVertical: 2, positionHorizontal: 0, value: 1 }],
            lines: [{ x1: 0, y1: 0, x2: 0, y2: 2, color: "#000000" },
            { x1: 0, y1: 0, x2: 3, y2: 0, color: "#000000" }]
        },
        {
            id: "70", chapter: 11,
            turtleData: { positionVertical: 0, positionHorizontal: 2, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} }
                ],
            specialObjects: [{ id: "house-blue", positionVertical: 3, positionHorizontal: 0, value: 1 }],
            lines: [{ x1: 2, y1: 0, x2: 2, y2: 1, color: "#000000" },
            { x1: 0, y1: 1, x2: 2, y2: 1, color: "#000000" },
            { x1: 0, y1: 1, x2: 0, y2: 3, color: "#000000" }]
        },
        {
            id: "71", chapter: 11,
            turtleData: { positionVertical: 1, positionHorizontal: 3, direction: 180 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "house-blue", positionVertical: 1, positionHorizontal: 0, value: 1 }],
            lines: [{ x1: 0, y1: 0, x2: 0, y2: 1, color: "#000000" },
            { x1: 0, y1: 0, x2: 3, y2: 0, color: "#000000" },
            { x1: 3, y1: 0, x2: 3, y2: 1, color: "#000000" }]
        },
        {
            id: "72", chapter: 11,
            turtleData: { positionVertical: 2, positionHorizontal: 2, direction: 180 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "house-blue", positionVertical: 2, positionHorizontal: 0, value: 1 }],
            lines: [{ x1: 0, y1: 0, x2: 0, y2: 2, color: "#000000" },
            { x1: 0, y1: 0, x2: 2, y2: 0, color: "#000000" },
            { x1: 2, y1: 0, x2: 2, y2: 2, color: "#000000" }]
        },
        {
            id: "73", chapter: 11,
            turtleData: { positionVertical: 0, positionHorizontal: 2, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },],
            specialObjects: [{ id: "house-pink", positionVertical: 2, positionHorizontal: 0, value: 1 },
            { id: "house-green", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "house-blue", positionVertical: 2, positionHorizontal: 3, value: 1 }],
            lines: [{ x1: 2, y1: 0, x2: 2, y2: 1, color: "#000000" },
            { x1: 2, y1: 1, x2: 3, y2: 1, color: "#0D47A1" }, //blue
            { x1: 3, y1: 1, x2: 3, y2: 2, color: "#0D47A1" }, //blue
            { x1: 1, y1: 1, x2: 2, y2: 1, color: "#009624" }, //green
            { x1: 1, y1: 1, x2: 1, y2: 2, color: "#009624" }, //green
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#D60000" }, //red
            { x1: 0, y1: 1, x2: 0, y2: 2, color: "#D60000" }] //red
        },
        {
            id: "74", chapter: 11,
            turtleData: { positionVertical: 1, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 4, positionHorizontal: 0, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "house-pink", positionVertical: 0, positionHorizontal: 0, value: 1 },
            { id: "house-blue", positionVertical: 3, positionHorizontal: 0, value: 1 },
            { id: "house-green", positionVertical: 4, positionHorizontal: 0, value: 1 }]
        },

        ]
    },
    {
        name: "13",
        tasks: [{
            id: "83", chapter: 13,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 1, x2: 2, y2: 1, color: "#e6e6e6" },
            { x1: 1, y1: 0, x2: 1, y2: 2, color: "#e6e6e6" }]
        },
        {
            id: "84", chapter: 13,
            turtleData: { positionVertical: 0, positionHorizontal: 0, direction: 90 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 4, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 5, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 6, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 1, y2: 0, color: "#BFD7E0" },
            { x1: 2, y1: 0, x2: 3, y2: 0, color: "#BFD7E0" },
            { x1: 4, y1: 0, x2: 5, y2: 0, color: "#BFD7E0" },
            { x1: 1, y1: 0, x2: 2, y2: 0, color: "#FFE5E6" },
            { x1: 3, y1: 0, x2: 4, y2: 0, color: "#FFE5E6" },
            { x1: 5, y1: 0, x2: 6, y2: 0, color: "#FFE5E6" }]
        },
        {
            id: "85", chapter: 13,
            turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 2, x2: 0, y2: 3, color: "#e6e6e6" },
            { x1: 0, y1: 2, x2: 1, y2: 2, color: "#e6e6e6" },
            { x1: 1, y1: 1, x2: 1, y2: 2, color: "#e6e6e6" },
            { x1: 1, y1: 1, x2: 2, y2: 1, color: "#e6e6e6" },
            { x1: 2, y1: 0, x2: 2, y2: 1, color: "#e6e6e6" },
            { x1: 2, y1: 0, x2: 3, y2: 0, color: "#e6e6e6" }]
        },
        {
            id: "86", chapter: 13,
            turtleData: { positionVertical: 1, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 1, y1: 0, x2: 2, y2: 0, color: "#e6e6e6" },
            { x1: 2, y1: 0, x2: 2, y2: 1, color: "#e6e6e6" },
            { x1: 2, y1: 1, x2: 3, y2: 1, color: "#e6e6e6" },
            { x1: 3, y1: 1, x2: 3, y2: 2, color: "#e6e6e6" },
            { x1: 2, y1: 2, x2: 3, y2: 2, color: "#e6e6e6" },
            { x1: 2, y1: 2, x2: 2, y2: 3, color: "#e6e6e6" },
            { x1: 1, y1: 3, x2: 2, y2: 3, color: "#e6e6e6" },
            { x1: 1, y1: 2, x2: 1, y2: 3, color: "#e6e6e6" },
            { x1: 0, y1: 2, x2: 1, y2: 2, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 0, y2: 2, color: "#e6e6e6" },
            { x1: 0, y1: 1, x2: 1, y2: 1, color: "#e6e6e6" },
            { x1: 1, y1: 0, x2: 1, y2: 1, color: "#e6e6e6" }]
        },
        {
            id: "87", chapter: 13,
            turtleData: { positionVertical: 3, positionHorizontal: 3, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 1, y2: 0, color: "#FFE5E6" },
            { x1: 1, y1: 1, x2: 2, y2: 1, color: "#FFE5E6" },
            { x1: 2, y1: 2, x2: 3, y2: 2, color: "#FFE5E6" },
            { x1: 1, y1: 0, x2: 1, y2: 1, color: "#FFE5E6" },
            { x1: 2, y1: 1, x2: 2, y2: 2, color: "#FFE5E6" },
            { x1: 3, y1: 2, x2: 3, y2: 3, color: "#FFE5E6" }]
        },
        {
            id: "88", chapter: 13,
            turtleData: { positionVertical: 0, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 4, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 5, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 6, isAllowed: true, walls: {} }
                ],
            specialObjects: [],
            lines: [{ x1: 0, y1: 0, x2: 1, y2: 0, color: "#e6e6e6" },
            { x1: 2, y1: 0, x2: 3, y2: 0, color: "#e6e6e6" },
            { x1: 4, y1: 0, x2: 5, y2: 0, color: "#e6e6e6" }]
        },
        ]
    },
    {
        name: "Extra",
        tasks: [{
            id: "89", chapter: 14,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 0, positionHorizontal: 1, value: 1 }]
        },
        {
            id: "90", chapter: 14,
            turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 1, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "91", chapter: 14,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "movablebox", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 1, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "92", chapter: 14,
            turtleData: { positionVertical: 2, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: false, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: false, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: false, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 2, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "93", chapter: 14,
            turtleData: { positionVertical: 0, positionHorizontal: 4, direction: 270 }, tiles:
                [{ positionHorizontal: 1, positionVertical: 0, isAllowed: true, walls: {} },
                { positionHorizontal: 0, positionVertical: 0, isAllowed: true, walls: {} },
                { positionHorizontal: 2, positionVertical: 0, isAllowed: true, walls: {} },
                { positionHorizontal: 3, positionVertical: 0, isAllowed: true, walls: {} },
                { positionHorizontal: 4, positionVertical: 0, isAllowed: true, walls: {} },
                { positionHorizontal: 5, positionVertical: 0, isAllowed: true, walls: {} },
                { positionHorizontal: 0, positionVertical: 1, isAllowed: true, walls: {} },
                { positionHorizontal: 1, positionVertical: 1, isAllowed: true, walls: {} },
                { positionHorizontal: 2, positionVertical: 1, isAllowed: true, walls: {} },
                { positionHorizontal: 3, positionVertical: 1, isAllowed: false, walls: {} },
                { positionHorizontal: 4, positionVertical: 1, isAllowed: false, walls: {} },
                { positionHorizontal: 5, positionVertical: 1, isAllowed: false, walls: {} },
                ],
            specialObjects: [{ id: "movablebox", positionVertical: 0, positionHorizontal: 3, value: 1 },
            { id: "destinationbox", positionVertical: 0, positionHorizontal: 5, value: 1 }]
        },
        {
            id: "94", chapter: 14,
            turtleData: { positionVertical: 3, positionHorizontal: 0, direction: 0 }, tiles:
                [{ positionVertical: 0, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 0, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 1, isAllowed: false, walls: {} },
                { positionVertical: 2, positionHorizontal: 1, isAllowed: false, walls: {} },
                { positionVertical: 3, positionHorizontal: 1, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 2, isAllowed: true, walls: {} },
                { positionVertical: 0, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 1, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 2, positionHorizontal: 3, isAllowed: true, walls: {} },
                { positionVertical: 3, positionHorizontal: 3, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "destinationbox", positionVertical: 3, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "95", chapter: 14,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 },
            tiles: [{ positionHorizontal: 1, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 3, isAllowed: true, walls: {} }], 
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "movablebox", positionVertical: 2, positionHorizontal: 1, value: 1 }]
        },
        {
            id: "96", chapter: 14,
            turtleData: { positionVertical: 3, positionHorizontal: 1, direction: 0 },
            tiles: [{ positionHorizontal: 1, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 0, isAllowed: false, walls: {} },
            { positionHorizontal: 0, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 3, isAllowed: true, walls: {} }], 
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 2, positionHorizontal: 0, value: 1 },
            { id: "movablebox", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 1, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "97", chapter: 14,
            turtleData: { positionVertical: 2, positionHorizontal: 2, direction: 0 },
            tiles: [{ positionHorizontal: 1, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 0, isAllowed: true, walls: {} }, 
            { positionHorizontal: 0, positionVertical: 1, isAllowed: true, walls: {} }, 
            { positionHorizontal: 0, positionVertical: 2, isAllowed: false, walls: {} },
            { positionHorizontal: 1, positionVertical: 0, isAllowed: true, walls: {} }, 
            { positionHorizontal: 1, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 0, isAllowed: true, walls: {} }, 
            { positionHorizontal: 2, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 2, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 0, isAllowed: false, walls: {} },
            { positionHorizontal: 3, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 2, isAllowed: false, walls: {} },
            ], 
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 0, positionHorizontal: 2, value: 1 },
            { id: "movablebox", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "destinationbox", positionVertical: 1, positionHorizontal: 3, value: 1 }]
        },
        {
            id: "98", chapter: 14,
            turtleData: { positionVertical: 1, positionHorizontal: 0, direction: 90 },
            tiles: [{ positionHorizontal: 1, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 0, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 1, isAllowed: true, walls: {} },
            { positionHorizontal: 0, positionVertical: 2, isAllowed: true, walls: { right: true } },
            { positionHorizontal: 1, positionVertical: 2, isAllowed: true, walls: { left: true } },
            { positionHorizontal: 2, positionVertical: 2, isAllowed: true, walls: { right: false } },
            { positionHorizontal: 3, positionVertical: 2, isAllowed: true, walls: { left: false } },
            { positionHorizontal: 0, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 1, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 2, positionVertical: 3, isAllowed: true, walls: {} },
            { positionHorizontal: 3, positionVertical: 3, isAllowed: true, walls: {} }],
            specialObjects: [{ id: "movablebox", positionVertical: 1, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 0, positionHorizontal: 1, value: 1 },
            { id: "destinationbox", positionVertical: 1, positionHorizontal: 3, value: 1 },
            { id: "movablebox", positionVertical: 1, positionHorizontal: 2, value: 1 },
            { id: "movablebox", positionVertical: 2, positionHorizontal: 1, value: 1 },
            { id: "movablebox", positionVertical: 2, positionHorizontal: 2, value: 1 },
            { id: "destinationbox", positionVertical: 3, positionHorizontal: 2, value: 1 }]
        },
        { 
            id: "99", chapter: 14,
            turtleData: {  positionVertical: 2,  positionHorizontal: 1,  direction: 0 },
            tiles: [  {   positionHorizontal: 1,   positionVertical: 1,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 1,   positionVertical: 0,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 0,   positionVertical: 0,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 0,   positionVertical: 1,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 0,   positionVertical: 2,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 1,   positionVertical: 2,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 2,   positionVertical: 2,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 2,   positionVertical: 1,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 2,   positionVertical: 0,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 3,   positionVertical: 0,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 3,   positionVertical: 1,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 3,   positionVertical: 2,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 4,   positionVertical: 0,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 4,   positionVertical: 1,   isAllowed: true,   walls: {}  },
            {   positionHorizontal: 4,   positionVertical: 2,   isAllowed: true,   walls: {}  } ], 
            specialObjects: [  {   id: "movablebox",   positionVertical: 1,   positionHorizontal: 1,   value: 1  },
            {   id: "movablebox",   positionVertical: 0,   positionHorizontal: 1,   value: 1  },
            {   id: "destinationbox",   positionVertical: 0,   positionHorizontal: 0,   value: 1  },
            {   id: "movablebox",   positionVertical: 1,   positionHorizontal: 0,   value: 1  },
            {   id: "movablebox",   positionVertical: 0,   positionHorizontal: 2,   value: 1  },
            {   id: "destinationbox",   positionVertical: 0,   positionHorizontal: 3,   value: 1  },
            {   id: "movablebox",   positionVertical: 2,   positionHorizontal: 3,   value: 1  },
            {   id: "destinationbox",   positionVertical: 2,   positionHorizontal: 4,   value: 1  } ]
        }
    ]
    }
]



// WEBPACK FOOTER //
// src/app/lib/exerciseData.js